import { render, staticRenderFns } from "./NavbarLeft.vue?vue&type=template&id=6cfbc617&scoped=true"
import script from "./NavbarLeft.vue?vue&type=script&lang=js"
export * from "./NavbarLeft.vue?vue&type=script&lang=js"
import style0 from "./NavbarLeft.vue?vue&type=style&index=0&id=6cfbc617&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbc617",
  null
  
)

export default component.exports